module.exports = __webpack_public_path__ + "static/media/rate.d119ae47.svg";